import store from '../store/index';

export function conditionallyRequired(condition) {
  // Vague, but Vue validator requires true if filed is valid, but inside template negative condition is used (value > 0)
  return () => !condition || store.state.translations.keys.form_field_required;
}
